import { render } from "./UnitOfMeasurement.vue?vue&type=template&id=74f89b85&scoped=true"
import script from "./UnitOfMeasurement.vue?vue&type=script&lang=js"
export * from "./UnitOfMeasurement.vue?vue&type=script&lang=js"

import "./UnitOfMeasurement.vue?vue&type=style&index=0&id=74f89b85&scoped=true&lang=css"
import "./UnitOfMeasurement.vue?vue&type=style&index=1&id=74f89b85&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74f89b85"]])

export default __exports__